/* eslint-disable @typescript-eslint/no-explicit-any */
import styled, { CSSProperties } from 'styled-components'
import { defaultButtonStyle, defaultIconStyle } from './Button.styled'

const BUTTON_PRESETS = ['filled', 'ghost'] as const
export type ButtonPresets = typeof BUTTON_PRESETS[number]

export function isButtonPreset(key: string): key is ButtonPresets {
  return BUTTON_PRESETS.includes(key as ButtonPresets)
}

// Gradient styles
const GhostButtonPrimary = styled.button`
  ${defaultButtonStyle}
  border: 2px solid ${({ theme }) => theme.colors.primary};
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.primary};
  :hover {
    border: 2px solid ${({ theme }) => theme.colors.primaryDarker};
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.primaryDarker};
  }
  :disabled {
    border: 2px solid ${({ theme }) => theme.colors.primaryDisabled};
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.primaryDisabled};
    background: ${({ theme }) => theme.colors.white};
  }
`
const RightIcon = (theme: any, disabled: boolean, style: CSSProperties) => ({
  marginLeft: 12,
  ...defaultIconStyle,
  ...style,
})

const LeftIcon = (theme: any, disabled: boolean, style: CSSProperties) => ({
  marginRight: 12,
  ...defaultIconStyle,
  ...style,
})

const GhostButtonSecondary = styled.button`
  ${defaultButtonStyle}
  border: 2x solid ${({ theme }) => theme.colors.secondary};
  box-sizing: border-box;
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.secondary};
  :hover {
    border: 2x solid ${({ theme }) => theme.colors.secondaryDarker};
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.secondaryDarker};
  }
  :disabled {
    border: 2x solid ${({ theme }) => theme.colors.secondaryDisabled};
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.secondaryDisabled};
    background: ${({ theme }) => theme.colors.white};
  }
`

const GhostButtonNeutral = styled.button`
  ${defaultButtonStyle}
  border: 2px solid ${({ theme }) => theme.colors.neutral};
  background: ${({ theme }) => theme.colors.white};
  color: ${({ theme }) => theme.colors.neutral};
  box-sizing: border-box;
  :hover {
    border: 2px solid ${({ theme }) => theme.colors.neutralDarker};
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.neutralDarker};
  }
  :disabled {
    border: 2px solid ${({ theme }) => theme.colors.neutralDisabled};
    box-sizing: border-box;
    color: ${({ theme }) => theme.colors.neutralDisabled};
    background: ${({ theme }) => theme.colors.white};
  }
`

const FilledButtonPrimary = styled.button`
  ${defaultButtonStyle}
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.white};
  :hover {
    background: ${({ theme }) => theme.colors.primaryDarker};
  }
  :disabled {
    background: ${({ theme }) => theme.colors.primaryDisabled};
  }
`

const FilledButtonSecondary = styled.button`
  ${defaultButtonStyle}
  background: ${({ theme }) => theme.colors.secondary};
  color: ${({ theme }) => theme.colors.white};
  :hover {
    background: ${({ theme }) => theme.colors.secondaryDarker};
  }
  :disabled {
    background: ${({ theme }) => theme.colors.secondaryDisabled};
  }
`

const FilledButtonNeutral = styled.button`
  ${defaultButtonStyle}
  background: ${({ theme }) => theme.colors.neutral};
  color: ${({ theme }) => theme.colors.white};
  :hover {
    background: ${({ theme }) => theme.colors.neutralDarker};
  }
  :disabled {
    background: ${({ theme }) => theme.colors.neutralDisabled};
  }
`

// Export all presets
export const buttonPresets: Record<
  ButtonPresets,
  { primary: any; secondary: any; neutral: any; rightIcon: any; leftIcon: any }
> = {
  ghost: {
    primary: GhostButtonPrimary,
    secondary: GhostButtonSecondary,
    neutral: GhostButtonNeutral,
    rightIcon: RightIcon,
    leftIcon: LeftIcon,
  },
  filled: {
    primary: FilledButtonPrimary,
    secondary: FilledButtonSecondary,
    neutral: FilledButtonNeutral,
    rightIcon: RightIcon,
    leftIcon: LeftIcon,
  },
}
